function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M24.7,52.9H0.4V39.1l5.9-14.5L8.9,6.7h15.8V52.9z M3.4,49.9h18.3V9.7H11.5L9.2,25.5L3.4,39.7V49.9z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 56.2,
  width: 24.5,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 8.9,
  y: 0.7,
  width: 15.6,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.4,
  y: 14.1,
  width: 14.4,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.4,
  y: 34.7,
  width: 14.4,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M59.5,52.9H35.3V6.7h15.8l2.5,17.9l5.9,14.5V52.9z M38.3,49.9h18.3V39.7l-5.9-14.5L48.5,9.7H38.3V49.9z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 35.4,
  y: 56.2,
  width: 24.5,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 35.4,
  y: 0.7,
  width: 15.6,
  height: 3
})))));

var SvgBinoculars = function SvgBinoculars(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/binoculars.59cf0a0b.svg";
export { SvgBinoculars as ReactComponent };